<template class="full-heigth">
  <div class="full-heigth">
    <el-dialog
      :fullscreen="true"
      @closed="onDialogClosed"
      :title="formData.id ? '編輯資料' : '新增資料'"
      :visible.sync="dialogFormVisible"
      top="2%"
      width="90%"
    >
      <el-form ref="dynamicValidateForm" v-loading="formLoading" :model="formData">
        <el-form-item label="封面照" :label-width="formLabelWidth">
          <div>
            <span>尺寸:840*480</span>
            <Upload
              ref="uploadRef"
              :accept="'.jpg,.jpeg,.png'"
              :limitText="'圖片須為.jpg,.jpeg,.png格式，限制不超過2000MB'"
              :payload="formData"
              :data-obj="fileObj"
              :limit-file-count="3"
              :use-drag="false"
              :action="'ToursCombine/saveArticle'"
              :auto-upload="false"
              :show-file-list="true"
              :form-on-loading-parent="formLoading"
              :btn-txt="'上傳'"
              :before-file-list="
                formData.fileInfo && formData.fileInfo.length ? formData.fileInfo[0].files : []
              "
            />
          </div>
        </el-form-item>

        <el-form-item
          label="影片連結"
          :label-width="formLabelWidth"
          prop="externalLink"
          :rules="[{ validator: validateLink, trigger: 'blur' }]"
        >
          <el-input
            v-model="formData.externalLink"
            autocomplete="off"
            placeholder="若有輸入影片連結，則封面會以影片優先顯示"
          />
        </el-form-item>

        <el-form-item
          label="標題"
          :label-width="formLabelWidth"
          prop="title"
          :rules="[{ required: true, message: '請輸入標題', trigger: 'blur' }]"
        >
          <el-input v-model="formData.title" autocomplete="off" maxlength="100" show-word-limit />
        </el-form-item>

        <el-form-item
          label="國家"
          :label-width="formLabelWidth"
          prop="country"
          :rules="[
            { type: 'array', message: '型別錯誤', trigger: 'blur' },
            { required: true, message: '請選擇國家', trigger: 'blur' },
          ]"
        >
          <el-cascader
            v-model="formData.country"
            :options="cascaderCountryOptions"
            style="width: 100%"
            :props="{
              multiple: true,
              value: 'id',
            }"
            collapse-tags
          ></el-cascader>
        </el-form-item>

        <el-form-item
          label="項目及分類"
          :label-width="formLabelWidth"
          prop="itemType"
          :rules="[
            { type: 'array', message: '型別錯誤', trigger: 'blur' },
            { required: true, message: '請選擇項目及分類', trigger: 'blur' },
          ]"
        >
          <el-cascader
            v-model="formData.itemType"
            :options="cascaderOptions"
            style="width: 100%"
            :props="{
              multiple: true,
              value: 'id',
              label: 'title',
              children: 'types',
            }"
            collapse-tags
          ></el-cascader>
        </el-form-item>

        <el-form-item label="內容" :label-width="formLabelWidth" prop="articleContent">
          <div>
            <tinymce ref="tinymce" v-model="formData.articleContent" :height="300" :type="16" />
          </div>
        </el-form-item>

        <el-form-item
          label="發文日期"
          :label-width="formLabelWidth"
          prop="buildDate"
          :rules="[
            {
              required: true,
              message: '請選擇發文日期',
              trigger: 'blur',
            },
          ]"
        >
          <el-date-picker
            v-model="formData.buildDate"
            type="datetime"
            placeholder="請選擇發文日期"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item
          label="hashTags"
          :label-width="formLabelWidth"
          prop="hashtags"
          :rules="[{ type: 'array', message: '型別錯誤', trigger: 'blur' }]"
        >
          <el-select
            v-model="formData.hashtags"
            multiple
            filterable
            remote
            reserve-keyword
            allow-create
            placeholder="請輸入關鍵字"
            :remote-method="remoteMethod"
            :loading="loading"
            :no-data-text="'無資料'"
            value-key="id"
            style="width: 100%"
          >
            <el-option v-for="item in options" :key="item.id" :label="item.title" :value="item">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="排序"
          :label-width="formLabelWidth"
          prop="sort"
          :rules="[
            {
              required: true,
              message: '請輸入排序',
              trigger: 'blur',
            },
          ]"
        >
          <el-input v-model.number="formData.sort" autocomplete="off" type="number" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onDialogClosed()">取 消</el-button>
        <el-button type="primary" @click="saveData('dynamicValidateForm')">儲 存</el-button>
      </div>
    </el-dialog>

    <el-form :inline="true" class="demo-form-inline">
      <el-form-item v-if="title == '全部'" label="項目篩選">
        <el-select v-model="listQuery.items" multiple collapse-tags placeholder="選擇分類">
          <el-option
            v-for="item in itemOptions"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="分類篩選">
        <el-select v-model="listQuery.types" multiple collapse-tags placeholder="選擇分類">
          <el-option
            v-for="item in typeOptions"
            :key="item.id"
            :label="item.title"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="標題及HashTag查詢">
        <el-input v-model="listQuery.qry" placeholder="輸入標題" />
      </el-form-item>
      <el-form-item v-if="this.$route.meta.title !== '綜合討論區'" label="作者篩選">
        <el-select v-model="listQuery.authors" multiple collapse-tags placeholder="選擇作者">
          <el-option v-for="item in authOptions" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList">查詢</el-button>
        <el-button type="success" @click="addData">建立</el-button>
      </el-form-item>
    </el-form>

    <div style="position: relative; height: 80%">
      <el-table
        v-loading="listLoading"
        :data="list"
        size="mini"
        border
        fit
        highlight-current-row
        style="width: 100%"
        height="100%"
        @sort-change="changeSort"
      >
        <el-table-column align="center" label="ID" width="60">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="封面照" width="150">
          <template slot-scope="scope">
            <el-image
              style="width: 100%; aspect-ratio: 1/1"
              :src="
                scope.row.externalLink
                  ? handleFormatVideoPic(scope.row.externalLink)
                  : scope.row.fileInfo !== null && scope.row.fileInfo.length > 0
                    ? scope.row.fileInfo[0].files[0].url
                    : 'https://fakeimg.pl/280x160/'
              "
              fit="contain"
              :preview-src-list="fileUrl(scope.row.fileInfo)"
            ></el-image>
          </template>
        </el-table-column>

        <el-table-column align="center" label="標題" width="190">
          <template slot-scope="{ row }">
            <a :href="changeURL(row)" target="_blank">
              <span style="color: rgb(64, 158, 255)">{{ row.title }}</span>
            </a>
          </template>
        </el-table-column>

        <el-table-column v-if="title == '全部'" align="center" label="項目" width="140">
          <template slot-scope="{ row }">
            <p v-for="item in itemType(row.itemType)" :key="item" style="margin: 2px 0px">
              {{ item }}
            </p>
          </template>
        </el-table-column>

        <el-table-column v-else align="center" label="分類" width="120">
          <template slot-scope="{ row }">
            <span>{{ typeShow(row.types) }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="國家" width="350">
          <template slot-scope="{ row }">
            <el-input
              :rows="6"
              type="textarea"
              disabled
              :value="showCountry(row.countryCascader)"
            ></el-input>
          </template>
          <!-- <template slot-scope="{ row }">
            <p
              v-for="item in showCountry(row.countryCascader)"
              :key="item"
              style="margin: 2px 0px"
            >
              {{ item }}
            </p>
          </template> -->
        </el-table-column>

        <el-table-column align="center" label="作者" width="120">
          <template slot-scope="{ row }">
            <span>{{ row.authorName }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="hashtags" width="120">
          <template slot-scope="{ row }">
            <span>{{ hashtagShow(row.hashtags) }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="建立時間"
          sortable="custom"
          width="120"
          prop="BuildDate"
        >
          <template slot-scope="{ row }">
            <span>{{ dataTime(row.buildDate) }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="排序" sortable="custom" width="80" prop="Sort">
          <template slot-scope="{ row }">
            <span>{{ row.sort }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          label="點閱次數"
          sortable="custom"
          width="120"
          prop="ViewCount"
        >
          <template slot-scope="{ row }">
            <el-tag type="primary">{{ row.viewCount }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="編輯" width="120">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-edit"
              class="filter-item"
              @click="editData(scope.row)"
              >編輯</el-button
            >
          </template>
        </el-table-column>

        <!-- <el-table-column align="center" :label="'檢舉列表'" width="150">
          <template slot-scope="scope">
            <el-button
              size="mini"
              class="filter-item"
              type="warning"
              icon="el-icon-edit"
              @click="reportData(scope.row)"
            >
              檢舉列表
            </el-button>
          </template>
        </el-table-column> -->

        <el-table-column align="center" :label="'刪除'" width="120">
          <template slot-scope="scope">
            <el-button
              size="mini"
              class="filter-item"
              type="danger"
              icon="el-icon-key"
              @click="deleteData(scope.row)"
            >
              刪除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      style="padding-top: 0; margin-top: 15px"
      v-show="total > 0"
      layout="total, prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { MessageBox, Message } from 'element-ui'
import Upload from '@/views/ita/components/fileUpload.vue'
import { dateFormat, dateFullFormat } from '@/utils'
import checkPermission from '@/utils/permission' // 权限判断函数
import Tinymce from '@/components/Tinymce'
import {
  deleteArticle,
  getArticle,
  getArticleContent,
  getHashTagList,
  getItemOfType,
  saveArticle,
  saveHashTagFromArticle,
} from '@/api/tcSetting'
import { getTravelAttractionsCascaderMenu } from '@/api/travel'
import { getTcRoleMembers } from '@/api/member'
import { convertFileToBase64 } from '@/utils/funcs'

var defaultForm = {
  id: null,
  fileInfo: [], //封面照-可多張圖片
  contentfileInfo: [],
  title: '',
  itemType: [], //項目及分類
  externalLink: '', //影片連結，有設定則封面照為影片
  hashtags: [],
  articleContent: '', //編輯器內容
  sort: 99,
  country: [],
  buildDate: dateFullFormat(new Date()),
}

export default {
  name: 'ItemData',
  components: {
    Pagination,
    Upload,
    Tinymce,
  },
  computed: {
    dataTime() {
      return function (value) {
        return dateFormat(value)
      }
    },
    typeShow() {
      return function (array) {
        var type = this.pageItemOfType.types
          .filter(item => {
            return array.indexOf(item.id) !== -1
          })
          .map(s => {
            return s.title
          })
        return type.toString()
      }
    },
    itemShow() {
      return function (array) {
        var item = this.itemOptions
          .filter(item => {
            return array.indexOf(item.id) !== -1
          })
          .map(s => {
            return s.title
          })
        return item.toString()
      }
    },
    fileUrl() {
      return function (array) {
        if (array == null) {
          return ['https://fakeimg.pl/280x160/']
        }
        if (array.length) {
          var list = array[0].files.map(x => {
            return x.url
          })
          return list
        } else {
          return ['https://fakeimg.pl/280x160/']
        }
      }
    },
    hashtagShow() {
      return function (array) {
        return array
          .map(item => {
            return '#' + item.title
          })
          .toString()
      }
    },
    itemType() {
      return function (value) {
        var list = []
        value.forEach(item => {
          var i = this.cascaderOptions.filter(x => {
            return x.id == item[0]
          })
          if (i.length) {
            var t = i[0].types.filter(x => {
              return x.id == item[1]
            })
            list.push(i[0].title + '-' + t[0].title)
          }
        })
        return list
      }
    },
    showCountry() {
      return function (value) {
        var strarray = []
        value.forEach(element => {
          var str = ''
          if (element.length == 3) {
            var firest = this.cascaderCountryOptions.filter(x => {
              return x.id == element[0]
            })
            var sec = firest[0].children.filter(x => {
              return x.id == element[1]
            })
            var three = sec[0].children.filter(x => {
              return x.id == element[2]
            })
            str = firest[0].label + ' / ' + sec[0].label + ' / ' + three[0].label
          } else {
            var firest = this.cascaderCountryOptions.filter(x => {
              return x.id == element[0]
            })
            str = firest[0].label
          }
          strarray.push(str)
        })
        return strarray.join('\n')
      }
    },
  },
  data() {
    var validateLink = (rule, value, callback) => {
      if (value == '' || value == null) {
        callback()
      } else if (value.includes('https://www.youtube.com/watch?')) {
        callback(new Error('請貼上正確的連結'))
      } else if (!value.includes('https://youtu.be/')) {
        callback(new Error('請貼上正確的連結'))
      } else {
        callback()
      }
    }
    return {
      validateLink: validateLink,
      formOnLoading: false,
      fileObj: { id: 0, type: 'agencyInfo', user: '' },
      isAdd: true,
      formLabelWidth: '120px',
      formData: defaultForm,
      dialogFormVisible: false,
      listLoading: false,
      formLoading: false,
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-ID',
        items: [],
        hashtags: [],
      },
      total: 0,
      list: [],
      itemOptions: [],
      typeOptions: [],
      authOptions: [],
      cascaderOptions: [],
      cascaderCountryOptions: [],
      loading: false,
      options: [],
      pageItemOfType: [],
      title: '',
    }
  },
  async created() {
    this.listLoading = true
    this.title = this.$route.meta.title
    await this.getItemType()
    await this.getRoleMembers()
    await this.getTravelCountryCascaderMenu()
    await this.initSelectFilterList()
    await this.getList()
  },
  methods: {
    checkPermission,
    changeURL(value) {
      var time = new Date(value.buildDate)
      var s = time.getFullYear().toString()
      var month = this.fill(time.getMonth() + 1, 2)
      const v = s.concat(month).concat(value.id)
      return process.env.VUE_APP_BASE_ARTICLE + '/' + v
    },
    fill(num, length) {
      for (var len = (num + '').length; len < length; len = num.length) {
        num = '0' + num
      }
      return num
    },
    async addData() {
      const vm = this
      vm.isAdd = true
      vm.formData = JSON.parse(JSON.stringify(defaultForm))
      vm.formData.buildDate = new Date()
      vm.dialogFormVisible = true
    },
    async saveData(formName) {
      const vm = this
      if (!vm.isAdd && !confirm(`確定要儲存該筆資料?`)) {
        return false
      }

      //$refs["uploadRef"] 不能放在 $refs[formName]的敘述裡面建立，組件裡面會找不到refs.upload
      let refUpload = this.$refs['uploadRef']
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let payload = await refUpload.combineFileAndPayload()
          if (!payload) {
            this.$message.error('檔案繫結表單發生未知錯誤，無法儲存資料。')
            return false
          }
          if (
            payload.fileInfo[0].files.length == 0 &&
            payload.fileIDs.length == 0 &&
            payload.externalLink == ''
          ) {
            this.$message.error('請上傳文章封面照')
            return false
          }
          vm.formLoading = true
          //新增hashtag
          var newHashTag = payload.hashtags.filter(x => {
            return typeof x == 'string'
          })
          if (newHashTag.length) {
            await saveHashTagFromArticle(newHashTag)
              .then(async response => {
                var HashTag = payload.hashtags.filter(x => {
                  return typeof x !== 'string'
                })
                HashTag = HashTag.concat(response.data)
                payload.hashtags = HashTag
              })
              .catch(error => {
                console.log(error)
              })
          }
          //儲存內文變成檔案
          payload.contentfileInfo = []
          if (payload.articleContent !== '') {
            const fileContent = new File([payload.articleContent], 'articleContent.txt', {
              type: 'text/plain',
            })
            const contentFileModel = {
              type: 34,
              files: [],
            }
            await convertFileToBase64(fileContent).then((resolve, reject) => {
              contentFileModel.files.push({
                fileName: 'articleContent.txt',
                base64: resolve,
              })
              payload.contentfileInfo.push(contentFileModel)
            })
          }

          payload.buildDate = dateFullFormat(payload.buildDate)
          console.log(payload)
          await saveArticle(payload)
            .then(res => {
              vm.onDialogClosed()
              vm.formLoading = false
              Message({
                message: '資料處理完成',
                type: 'success',
                duration: 5 * 1000,
              })
              vm.getList()
            })
            .catch(err => {
              console.log(err)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async getRoleMembers() {
      var roles = []
      switch (this.$route.meta.title) {
        case '全部':
          roles = ['TC-YOUTUBER', 'TC-COMPANY', 'TC-BLOGGER', 'TC-MANUFACTURER', 'TC-ITA-STAFF']
          break
        case '旅遊新聞':
          roles = ['TC-MANUFACTURER', 'TC-ITA-STAFF']
          break
        case '旅遊知識':
          roles = ['TC-ITA-STAFF']
          break
        case '旅遊專欄':
        case '旅遊影片':
          roles = ['TC-YOUTUBER', 'TC-COMPANY', 'TC-BLOGGER', 'TC-ITA-STAFF']
          break
        default:
          break
      }
      await getTcRoleMembers({ roles: roles })
        .then(response => {
          console.log(response)
          this.authOptions = response.data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    async getItemType() {
      await getItemOfType().then(response => {
        this.cascaderOptions = response.data
      })
    },
    async getTravelCountryCascaderMenu() {
      await getTravelAttractionsCascaderMenu().then(response => {
        this.cascaderCountryOptions = response.data
      })
    },
    async initSelectFilterList() {
      var item = this.cascaderOptions.filter(x => {
        return x.title == this.$route.meta.title
      })
      if (item.length) {
        this.typeOptions = item[0].types
      } else {
        this.itemOptions = []
        this.typeOptions = []
        this.cascaderOptions.forEach(item => {
          if (
            this.itemOptions.findIndex(x => {
              return x.id == item.id
            }) == -1
          ) {
            this.itemOptions.push(item)
          }
          item.types.forEach(type => {
            if (
              this.typeOptions.findIndex(x => {
                return x.id == type.id
              }) == -1
            ) {
              this.typeOptions.push(type)
            }
          })
        })
      }
    },
    async getList() {
      const vm = this
      vm.listLoading = true
      var item = this.cascaderOptions.filter(x => x.title == this.$route.meta.title)
      if (item.length) {
        this.pageItemOfType = item[0]
        this.listQuery.items = [this.pageItemOfType.id]
      } else {
        this.pageItemOfType.types = []
        this.cascaderOptions.forEach(item => {
          item.types.forEach(type => {
            if (
              this.pageItemOfType.types.findIndex(x => {
                return x.id == type.id
              }) == -1
            ) {
              this.pageItemOfType.types.push(type)
            }
          })
        })
      }
      if (this.listQuery.qry !== '') {
        this.listQuery.hashtags = [this.listQuery.qry]
      } else {
        this.listQuery.hashtags = []
      }
      await getArticle(this.listQuery).then(response => {
        console.log(response)
        vm.listLoading = false
        this.list = response.data.data
        this.total = response.data.totalItemCount
      })
    },
    onDialogClosed() {
      let refUpload = this.$refs['uploadRef']
      refUpload.clearFiles()
      this.$refs['dynamicValidateForm'].clearValidate()
      this.formData = JSON.parse(JSON.stringify(defaultForm))
      this.$refs['tinymce'].setValue('') //重置內容
      this.options = []
      this.dialogFormVisible = false
    },
    async editData(d) {
      console.log(d)
      const vm = this
      vm.isAdd = false
      vm.formData = JSON.parse(JSON.stringify(d))
      vm.formData.country = vm.formData.countryCascader
      vm.formData.contentfileInfo = []
      vm.options = vm.formData.hashtags
      vm.dialogFormVisible = true
      this.formLoading = true
      await getArticleContent(vm.formData.id).then(response => {
        vm.formData.articleContent = response.data
        this.$refs['tinymce'].setValue(vm.formData.articleContent)
        this.formLoading = false
      })
    },
    async deleteData(row) {
      let vm = this
      if (confirm(`確定刪除【${row.title}】文章資訊?\r\n`)) {
        vm.$message({
          message: '操作成功',
          type: 'success',
        })
        vm.listLoading = true
        let resp = await deleteArticle({ id: row.id })
        if (resp.success) {
          await vm.getList()
          vm.$message({
            message: '操作成功',
            type: 'success',
          })
        }
        vm.listLoading = false
      }
    },
    reportData(row) {},
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true
        setTimeout(async () => {
          await getHashTagList({ query: query })
            .then(response => {
              this.loading = false
              this.options = response.data
            })
            .catch(error => {
              console.log(error)
            })
        }, 800)
      } else {
        this.options = []
      }
    },
    async changeSort(val) {
      console.log(val)
      var order = val.order == 'descending' ? '-' : val.order == null ? '-ID' : '+'
      this.listQuery.sort = val.order == null ? order : order + val.prop
      if (val.prop == 'ViewCount') {
        this.listQuery.sort = this.listQuery.sort + ',-BuildDate'
      }
      await this.getList()
    },
    handleFormatVideoPic(link) {
      const hasYt = link.includes('youtu')
      const ytIdData = hasYt ? link.split('/').pop() : null
      const ytId = ytIdData.includes('?') ? ytIdData.split('?').shift() : ytIdData
      const ytImg = `https://img.youtube.com/vi/${ytId}/sddefault.jpg`
      return hasYt ? ytImg : 'https://fakeimg.pl/70x70/'
    },
  },
}
</script>
<style>
.full-heigth {
  position: relative;
  height: 100%;
}

.el-dialog__body {
  padding-top: 0px;
}
</style>
